import { render, staticRenderFns } from "./CreateTag.vue?vue&type=template&id=6f9dacb3&"
import script from "./CreateTag.vue?vue&type=script&lang=ts&"
export * from "./CreateTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports